"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.ToggleWrapper = exports.LiveTitleWrap = exports.InteractionOverlay = exports.VideoOverlayContainer = exports.Overlay = exports.InteractionTool = exports.StyledPlayer = exports.LiveWrapper = exports.LiveContainer = exports.BrightCoveContainer = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var BrightCoveContainer = (0, _styled.default)('div')({
  width: '100%',
  height: '100%',
  '.video-js, .brightcove-react-player-loader': {
    width: '100%',
    height: '100%'
  },
  '.vjs-modal-dialog .vjs-modal-dialog-content': {
    zIndex: 0
  }
});
exports.BrightCoveContainer = BrightCoveContainer;
var LiveContainer = (0, _styled.default)('div')(function (_ref) {
  var _ref$theme = _ref.theme,
      livePlayer = _ref$theme.livePlayer,
      mediaQueries = _ref$theme.mediaQueries,
      slug = _ref$theme.slug,
      space = _ref$theme.space;
  return _defineProperty({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginTop: livePlayer[slug] ? "-".concat(space[livePlayer[slug].topMargin]) : 'initial'
  }, mediaQueries.medium, {
    marginTop: livePlayer[slug] ? "-".concat(space[livePlayer[slug].topMarginDesktop]) : 'initial'
  });
});
exports.LiveContainer = LiveContainer;
var LiveWrapper = (0, _styled.default)('div')(function (_ref3) {
  var _ref3$theme = _ref3.theme,
      space = _ref3$theme.space,
      mediaQueries = _ref3$theme.mediaQueries;
  return _defineProperty({
    display: 'flex',
    flexWrap: 'wrap',
    marginBottom: space.base,
    width: '100%'
  }, mediaQueries.large, {
    flexWrap: 'nowrap',
    overflow: 'hidden'
  });
});
exports.LiveWrapper = LiveWrapper;
var StyledPlayer = (0, _styled.default)('div')(function (_ref5) {
  var _ref6;

  var mediaQueries = _ref5.theme.mediaQueries,
      splitSize = _ref5.splitSize,
      hasVotemo = _ref5.hasVotemo;
  var splitWidthLarge = hasVotemo ? '65%' : '75%';
  var splitWidthXLarge = hasVotemo ? '70%' : '75%';
  return _ref6 = {
    marginTop: '0 !important',
    position: 'relative',
    minHeight: '30rem',
    minWidth: '100%'
  }, _defineProperty(_ref6, mediaQueries.large, {
    minHeight: splitSize ? '48rem' : '59rem',
    minWidth: splitSize ? splitWidthLarge : '100%',
    // TODO during animation there is a small gap appearing which it would be great if we can remove it
    transition: 'all 1s'
  }), _defineProperty(_ref6, mediaQueries.xlarge, {
    minWidth: splitSize ? splitWidthXLarge : '100%'
  }), _ref6;
});
exports.StyledPlayer = StyledPlayer;
var InteractionTool = (0, _styled.default)('div')(function (_ref7) {
  var _ref8;

  var mediaQueries = _ref7.theme.mediaQueries,
      hasVotemo = _ref7.hasVotemo;
  return _ref8 = {
    position: 'relative',
    minHeight: hasVotemo ? '48rem' : '42rem',
    minWidth: '100%'
  }, _defineProperty(_ref8, mediaQueries.medium, {
    minHeight: '36rem'
  }), _defineProperty(_ref8, mediaQueries.large, {
    minWidth: hasVotemo ? '35%' : '25%'
  }), _defineProperty(_ref8, mediaQueries.xlarge, {
    minWidth: hasVotemo ? '30%' : '25%'
  }), _ref8;
});
exports.InteractionTool = InteractionTool;
var Overlay = (0, _styled.default)('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  background: 'rgba(4, 4, 4, 0.84)',
  zIndex: '1',
  display: 'flex',
  flexDirection: 'column-reverse',
  justifyContent: 'flex-end'
});
exports.Overlay = Overlay;
var VideoOverlayContainer = (0, _styled.default)(Overlay)(function (_ref9) {
  var _h2, _h3;

  var _ref9$theme = _ref9.theme,
      livePlayer = _ref9$theme.livePlayer,
      mediaQueries = _ref9$theme.mediaQueries,
      space = _ref9$theme.space;
  return {
    h1: _defineProperty({
      color: 'white',
      paddingLeft: space.large,
      marginBottom: space.medium,
      lineHeight: 1,
      fontSize: '3rem'
    }, mediaQueries.large, {
      paddingLeft: '9rem',
      marginTop: space.xxxlarge,
      marginBottom: space.large,
      fontSize: '6.2rem'
    }),
    h2: (_h2 = {
      color: 'white',
      paddingLeft: space.large,
      paddingRight: space.large,
      marginBottom: space.medium,
      lineHeight: 1
    }, _defineProperty(_h2, mediaQueries.large, {
      paddingLeft: '9rem',
      marginTop: space[livePlayer.overlayMarginTop],
      marginBottom: 0
    }), _defineProperty(_h2, '&::before', {
      content: '""'
    }), _h2),
    h4: (_h3 = {
      color: 'white',
      paddingLeft: space.large,
      paddingRight: space.large,
      marginBottom: space.medium,
      lineHeight: 1
    }, _defineProperty(_h3, mediaQueries.large, {
      paddingLeft: '9rem',
      marginTop: space.medium,
      marginBottom: space.large
    }), _defineProperty(_h3, '&::before', {
      content: '""'
    }), _h3),
    a: _defineProperty({
      margin: "".concat(space.base, " ").concat(space.large, " ").concat(space.large)
    }, mediaQueries.large, {
      marginLeft: '9rem'
    }),
    img: _defineProperty({
      width: '10rem',
      marginLeft: space.large,
      marginBottom: space.large
    }, mediaQueries.large, {
      width: '15rem',
      marginLeft: '9rem',
      marginBottom: '12rem'
    })
  };
});
exports.VideoOverlayContainer = VideoOverlayContainer;
var InteractionOverlay = (0, _styled.default)(Overlay)({
  background: '#000',
  justifyContent: 'center',
  alignItems: 'center'
});
exports.InteractionOverlay = InteractionOverlay;
var LiveTitleWrap = (0, _styled.default)('iframe')(function (_ref10) {
  var _ref11;

  var mediaQueries = _ref10.theme.mediaQueries;
  return _ref11 = {
    height: '20rem',
    marginBottom: '1.5rem',
    width: '100%'
  }, _defineProperty(_ref11, mediaQueries.small, {
    height: '14rem'
  }), _defineProperty(_ref11, mediaQueries.medium, {
    height: '10rem'
  }), _ref11;
});
exports.LiveTitleWrap = LiveTitleWrap;
var ToggleWrapper = (0, _styled.default)('div')(function (_ref12) {
  var _ref12$theme = _ref12.theme,
      space = _ref12$theme.space,
      colors = _ref12$theme.colors,
      mediaQueries = _ref12$theme.mediaQueries;
  return _defineProperty({
    display: 'none'
  }, mediaQueries.large, {
    display: 'flex',
    background: colors.offwhite,
    justifyContent: 'center',
    padding: space.small,
    width: '25%',
    alignItems: 'center'
  });
});
exports.ToggleWrapper = ToggleWrapper;